import React from 'react';
import { ProductImage } from './product-image';
import { ProductLabel } from './product-label';
import { imageWrapper, productLabel } from './styles';
import { imageWrapper as sponsoredImageWrapper } from 'common/components/sponsored-carousel/product-card/styles';
import { ProductType, ProductsElementName } from 'common/components/product-card/types';
import { simplifiedImageWrapper } from '../sponsored-carousel/product-card/common-styles';
import { MarkerStrategy } from './marker-strategy';

export const DATA_QA_PRODUCT_IMAGE = 'product-image';

type ProductImageLinkProps = {
  link: string;
  product: ProductType;
  onClick: (elementName: ProductsElementName) => void;
  type: 'large-card' | 'list';
  inWidget?: boolean;
  label: 'STD' | 'LOF' | 'BPR' | 'PIM' | 'WIZ';
  loyaltyRewardLabel?: string;
  isPageTop?: boolean;
  isSimplifiedVariant?: boolean;
  isSponsored?: boolean;
};
export const ProductImageLink: React.FC<ProductImageLinkProps> = ({
  link,
  product,
  onClick,
  type,
  inWidget,
  label,
  loyaltyRewardLabel,
  isPageTop = false,
  isSimplifiedVariant,
  isSponsored = false,
}) => {
  const getWrapperClassName = () => {
    if (isSimplifiedVariant) return simplifiedImageWrapper;
    if (isPageTop) return sponsoredImageWrapper;
    return imageWrapper;
  };

  return (
    <a
      href={link}
      className={getWrapperClassName()}
      onClick={() => onClick('productPhotoLink')}
      aria-label={product.displayedName}
      data-qa-product-image=""
      data-qa={DATA_QA_PRODUCT_IMAGE}
      tabIndex={-1}
    >
      <ProductImage
        alt={product.displayedName}
        mediaMainPhoto={product.mediaMainPhoto}
        view={type}
        withoutSchema={inWidget}
      />
      {loyaltyRewardLabel && (
        <MarkerStrategy
          loyaltyRewardLabel={loyaltyRewardLabel}
          isSponsored={isSponsored}
          isSimplifiedVariant={isSimplifiedVariant}
        />
      )}
      <ProductLabel labelType={label} className={productLabel} />
    </a>
  );
};
